export const required = (value, name) => {
    if (!value.toString().trim().length) {
        // We can return string or jsx as the 'error' prop for the validated Component
        return `${name} is required`;
    }
    return false;
};